import {useEffect} from 'react';
import {assignProps, toIntent} from '@sail/engine';
import {css} from '../../css';

function isTouchDevice() {
  return (
    (typeof window !== 'undefined' && 'ontouchstart' in window) ||
    (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0)
  );
}

const globalPointerEventsNoneStyles = css.global({
  [`[data-delayed-pointer-event-css-for-overlays] *, [data-delayed-pointer-event-css-for-overlays] *::before, [data-delayed-pointer-event-css-for-overlays] *::after`]:
    {
      // @ts-expect-error - !important is not typed
      pointerEvents: 'none !important',
    },
});

/**
 * React hook that returns a Sail Intent to apply to the conteiner.
 *
 * This delay is a temporary fix for touch devices.
 * When opening an overlay from an `onPress` event on a button, it gives time for the click event to fire, before allowing clicks on anything rendered on top of the button.
 * Otherwise, the click event would be fired on whatever the overlay renders on top of the opening button.
 *
 * Once `onPress` is fixed so that it fires at the same time as the `onClick` callback, this delay can be removed.
 */
export function useDelayedPointerEventCssForOverlays(
  containerRef: React.RefObject<HTMLElement | undefined>,
) {
  useEffect(() => {
    if (!isTouchDevice()) {
      return;
    }

    setTimeout(() => {
      containerRef.current?.removeAttribute(
        `data-delayed-pointer-event-css-for-overlays`,
      );
    }, 30);
  }, [containerRef]);

  if (!isTouchDevice()) {
    return null;
  }

  return toIntent([
    globalPointerEventsNoneStyles,
    assignProps({
      'data-delayed-pointer-event-css-for-overlays': '',
    }),
  ]);
}
